<template>
    <div class="cb-container flex row center vertical-center space-evenly">
        <div class="flex row">
            <div class="fit-content" style="margin: 15px 35px 0 0;">
                <img :src="require('../../assets/Desktop/About_Us/01-img.svg')" alt="">
            </div>
            <div class="right column">
                <h1 class="re-title align-right" style="margin-bottom: 15px;">{{header_content.title}}</h1>
                <p class="re-text align-right">{{header_content.description}}</p>
            </div>
        </div>
        <div class="flex column md-container">
            <div v-for="item in items_left" :key="item.title" class="flex">
                <div class="flex vertical-center mg-spacing">
                    <img :src="item.icon" :alt="item.title">
                </div>
                <div>
                    <h3 class="cb-item-title">{{item.title}}</h3>
                    <p class="cb-item-text">{{item.text}}</p>
                </div>
            </div>
        </div>
        <div class="flex column md-container">
            <div v-for="item in items_right" :key="item.title" class="flex">
                <div class="flex vertical-center mg-spacing">
                    <img :src="item.icon" :alt="item.title">
                </div>
                <div>
                    <h3 class="cb-item-title">{{item.title}}</h3>
                    <p class="cb-item-text">{{item.text}}</p>
                </div>
            </div>
        </div>
        <div class="flex lg-container">
            <re-panel-nav
                v-on:app="sendMessage('re-the-applciation')"
                v-on:offer="sendMessage('re-the-offering')"
                v-on:company="sendMessage('re-company-breakdown')"
            ></re-panel-nav>
        </div>
    </div>
</template>

<script>
    import Panel_Nav from './Panel_Nav.vue'
    export default {
        data () {
            return{
                header_content: {
                    'title': 'Luxurious\nServices',
                    'description': 'It is estimated that there are 5M potential customers within the Business defined trading area that are estimated to spend $93.5B to seek the most profitable market segments in the target markets overall, the Business will focus on these following areas within the target market'
                },
                items_left: [
                    {'title': 'TRAVEL', 'text': 'Amazing & Elegant\ntravel arrangements', 'icon': require('../../assets/Desktop/Home_Landing/Travel_Icon.svg')},
                    {'title': 'STAY', 'text': 'Enjoy 5 star\nhotel services', 'icon': require('../../assets/Desktop/Home_Landing/Stay_Icon.svg')},
                    {'title': 'PARTY', 'text': 'Let loose at the\nworld’s best parties', 'icon': require('../../assets/Desktop/Home_Landing/Party_Icon.svg')},
                ],
                items_right: [
                    {'title': 'RESTAURANTS', 'text': 'Dine in for decadent\nworld class meals', 'icon': require('../../assets/Desktop/Home_Landing/Restaurant_Icon.svg')},
                    {'title': 'EXPLORE', 'text': 'Excursions to the\nworld’s best views', 'icon': require('../../assets/Desktop/Home_Landing/Star_Icon.svg')},
                    {'title': 'EXPERIENCE', 'text': 'Experience the best of\nwhat the world offers', 'icon': require('../../assets/Desktop/Home_Landing/Star_Icon.svg')},
                ]
            }
        },
        mounted: function() {
            let nav_location = document.querySelectorAll('.cb-container')[0].querySelectorAll('.cb-item')[0]
            nav_location.style['font-size'] = '15px';
            nav_location.style['color'] = '#DAAE3E';
        },
        components: {
            're-panel-nav': Panel_Nav
        },
        methods: {
            sendMessage(message){
                this.$emit('scroll_location', message)
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 880px) {

    }

    .cb-container {
        height: 650px;
        overflow: hidden;
    }

    .re-title {
        color: #333333;
        white-space: pre;
        text-align: left;
    }

    .re-text {
        color: #333333;
        font-family: Trirong;
        font-size: 15px;
        letter-spacing: 1px;
        line-height: 28px;
        width: 279px;
        height: 315px;
        text-align: left;
        margin: 15px 0;
    }

    .cb-item-title {
        text-align: left;
        color: #666666;
        font-family: Oswald;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 1.78px;
        line-height: 21px;
    }

    .cb-item-text {
        text-align: left;
        color: #666666;
        font-family: Trirong;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 1.13px;
        line-height: 18px;
        white-space: pre;
    }

    .align-right {
        margin: auto 0 auto 0;
    }

    .mg-spacing {
        margin: auto 25px auto 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/home/Company_Breakdown.vue